import * as React from 'react';
import styled from 'styled-components';

import { Section } from '@process-advisor/process-miner/modals/findings/section';
import { DataGrid } from '@process-advisor/process-miner/findings/dataGrid';
import { SingleBlock } from '@process-advisor/process-miner/slicers/singleBlock';
import { getShadow, getZIndex } from '@process-advisor/process-miner/shared/theme';
import { type ColDef, themeAlpine } from 'ag-grid-community';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import '@process-advisor/process-miner/shared/gridStyles.css'

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 400px;
    box-shadow: ${getShadow('pane')};
    z-index: ${getZIndex('panel')};
    padding-bottom: 5px;
    margin-top: 10px
`;

const FindingWrapper = styled.div`
    margin-top: 7px;
    margin-bottom: 20px;
`;


export type Row = {};
let dateString

export const FindingDetails = ({finding,filterSummary}) => {
 
    const [findingRows, setFindingRows] = React.useState<Row[]>([]);
    const [modelName, setModelName]  = React.useState('');
    
    React.useEffect(() => {
        setFindingRows(filterSummary);
        setModelName(apiProvider.getModelFileName())

        const currentDate = new Date();
        dateString = currentDate.toDateString();

    }, [filterSummary]);

    return (
            <Wrapper>
                <SingleBlock width="15%">
                    <Section title='Data Model'/>
                </SingleBlock>
                <SingleBlock width="85%">
                    <FindingWrapper>
                        {modelName}
                    </FindingWrapper>
                </SingleBlock>

                <SingleBlock width="15%">
                    <Section title='Date'/>
                </SingleBlock>
                <SingleBlock width="85%">
                    <FindingWrapper>
                        {dateString}
                    </FindingWrapper>
                </SingleBlock>

                <SingleBlock width="15%">
                    <Section title='Finding'/>
                </SingleBlock>
                <SingleBlock width="85%">
                    <FindingWrapper>
                        {finding}
                    </FindingWrapper>
                </SingleBlock>
                <SingleBlock width="15%">
                    <Section title='Criteria:'/>
                </SingleBlock>
                <SingleBlock width="85%">
                <DataGrid
                    rows={findingRows}
                    height="110px" />
                </SingleBlock>
            </Wrapper>
    );
};


